import { CACHE_TIME, STALE_TIME } from 'helpers/constants';
import { generateCreditObjectsQueryKey } from 'dataLayer/queryKeys';
import { errorHandler } from 'helpers/utils';
import { getCreditObjects } from './api';

export const creditObjectsQuery = (dealId: string) => ({
  queryKey: generateCreditObjectsQueryKey(dealId),
  queryFn: () => getCreditObjects(dealId),
  cacheTime: CACHE_TIME,
  staleTime: STALE_TIME,
  onError: (error: unknown) => errorHandler(error),
});
